export const emmaDocsURL = 'https://baseplate.legogroup.io/docs/default/component/emma';
export const deploymentStrategyDocURL = `${emmaDocsURL}/how_to/manage_deployment_rollouts/`;
export const firewallConfigurationDocURL = `${emmaDocsURL}/how_to/firewall_configuration/`;
export const adPortalURL = 'https://myaccount.microsoft.com/groups';
export const netboxURL = 'https://netbox.legogroup.io';
export const osChangelogURL = `${emmaDocsURL}/os_changelog/`;
export const emmaOs1ChangelogURL = `${emmaDocsURL}/os_changelog/emmaos_1/`;
export const emmaOs2ChangelogURL = `${emmaDocsURL}/os_changelog/emmaos_2/`;
export const emmaOs3ChangelogURL = `${emmaDocsURL}/os_changelog/emmaos_3/`;
export const emmaTeamsChannelUrl =
  'https://teams.microsoft.com/l/channel/19%3ae9938c7da2da443280c7aed0f1e80c98%40thread.skype/EMMA?groupId=ecf9587b-7f13-48da-85fa-d6e62472a771&tenantId=1d063515-6cad-4195-9486-ea65df456faa';
export const emmaGithubURL = 'https://github.com/LEGO/EMMA';
